import React from 'react';
import ActionIconButton from './ActionIconButton';

const ReverseButton = ({title = 'Estornar', ...props}) => (
    <ActionIconButton variant="reverse" title={title} {...props}/>
);

export default ReverseButton;
